module.exports = __webpack_public_path__ + "./images/40e1445034a7e04c321f1b924bc3491a.webp";